import { render, staticRenderFns } from "./noPrevilages.vue?vue&type=template&id=1480818c"
import script from "./noPrevilages.vue?vue&type=script&lang=js"
export * from "./noPrevilages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports